/**
 * 兑换查询
 */
export interface ExchangeInfo {
  /**
   * 手机号
   */
  phone: string,
  /**
   * 会员号
   */
  user_code: string,
  /**
   * 会员客户id(只有会员可以兑换优惠券)
   */
  member_id?: number,
  /**
   * 有效时间
   * - start_at 开始时间
   * - end_at 结束时间
   */
  time_range: string[],
  /**
   * 优惠券id
   */
  coupons_id: number,
  /**
   * 活动id
   */
  ticket_act_id: number,
}

/**
 * 服务记录查询表单默认值
 */
export const defaultExchangeInfo: ExchangeInfo = {
  phone: '',
  user_code: '',
  member_id: null,
  time_range: [],
  coupons_id: null,
  ticket_act_id: null,
};